module.exports = __webpack_public_path__ + "packs/media/images/lexiqamus/landing/hareket1-821f95f3102f73815e9dfae4c8e860a6.jpg";